const notesContainerTabsEnum = Object.freeze({
  PHOTO_NOTES: 'Photo Notes',
  NOTES: 'Notes',
});
export default notesContainerTabsEnum;
